var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cookie__button"},[_c('button',{staticClass:"cookie__button-label apollo__link",attrs:{"tabindex":"0","role":"button","aria-pressed":"true"},on:{"click":_vm.accept}},[_c('bdi',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }